import { render, staticRenderFns } from "./CbsBudgetTrip.vue?vue&type=template&id=17c90ed4&scoped=true"
import script from "./CbsBudgetTrip.vue?vue&type=script&lang=js"
export * from "./CbsBudgetTrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c90ed4",
  null
  
)

export default component.exports